import { render } from "./ListProducts.vue?vue&type=template&id=8fd0e346&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"

import "./ListProducts.vue?vue&type=style&index=0&id=8fd0e346&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd0e346"]])

export default __exports__